import { Section } from '@/api/types/getOnePost';

export const getSectionContentHtml = (content: Section['content']): string => {
  if (!content) return '';
  if (typeof content === 'string') return content;
  if (typeof content === 'object' && typeof content.html === 'string') {
    return content.html;
  }
  return '';
};
